<template>
  <div @keyup.enter="confirm">
    <div class="filter-title">{{ title }}</div>

    <div v-for="(item, i) in list" :key="i" class="radio">
      <UiRadio
        class="radio-item"
        :name="'option' + queryKey"
        :option-value="item.value"
        :label="item.label"
        :model="model"
        @change="(value) => (model = value)"
      />
    </div>

    <div class="filter-operation">
      <UiButton :class="['button', 'is-small', 'is-blue']" @click="confirm"> Применить </UiButton>
      <UiButton :class="['button', 'is-small', 'is-light']" @click="reset"> Очистить </UiButton>
    </div>
  </div>
</template>

<script>
import common from './common'

export default {
  components: {
    UiRadio: () => import('@/components/UiRadio.vue'),
    UiButton: () => import('@/components/UiButton.vue'),
  },
  mixins: [common],
  data() {
    return {
      model: '',
    }
  },
  watch: {
    '$route.query': {
      handler: 'setQuerySelected',
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.updateQueryParams({
        query: { ...this.$query, page: null, [this.queryKey]: null },
      })

      this.closeFn()
    },

    confirm() {
      this.updateQueryParams({
        query: { ...this.$query, page: null, [this.queryKey]: this.model },
      })

      this.closeFn()
    },

    setQuerySelected() {
      this.model = this.$query[this.queryKey]
    },
  },
}
</script>

<style lang="scss" scoped>
// stylelint-disable
.radio {
  margin: 0 0 rem(4px) 0;

  &-item {
    @include createFlex(flexbox, nowrap, row, flex-start, stretch, stretch);
  }

  /deep/ .label {
    width: 100%;
  }
  /deep/ input {
    @include flex-shrink(0);
  }
}
</style>
